export default "__VITE_ASSET__DTdtSPaL__"